import { render, staticRenderFns } from "./yxwelcome.vue?vue&type=template&id=040be822&scoped=true&"
import script from "./yxwelcome.vue?vue&type=script&lang=js&"
export * from "./yxwelcome.vue?vue&type=script&lang=js&"
import style0 from "./yxwelcome.vue?vue&type=style&index=0&id=040be822&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040be822",
  null
  
)

export default component.exports